const Joi = require("joi");

const keywordSchema = (data) => {
  const schema = Joi.object({
    MessageKeyWord: Joi.string().trim().min(1).required().messages({
      "any.required": "Please enter keyword.",
      "string.empty": "Please enter keyword.",
    }),

    WebUserSentActionID: Joi.number()
      .required()
      .custom((value, helpers) => {
        // Check if the value is 3
        if (value === 3) {
          return helpers.message("Please select Web User Action.");
        }
        return value; // If the value is not 3, return it as is
      })
      .messages({
        "any.required": "Please select Web User Action.",
        "any.empty": "Please select Web User Action.",
      }),

    InmateSentActionID: Joi.number()
      .required()
      .custom((value, helpers) => {
        // Check if the value is 3
        if (value === 3) {
          return helpers.message("Please select Inmate Action.");
        }
        return value; // If the value is not 3, return it as is
      })
      .messages({
        "any.required": "Please select Inmate Action.",
        "any.empty": "Please select Inmate Action.",
      }),

    KeyWordFilterTypeID: Joi.number()
      .required()
      .custom((value, helpers) => {
        // Check if the value is 2
        if (value === 2) {
          return helpers.message("Please select Filter Type.");
        }
        return value; // If the value is not 2, return it as is
      })
      .messages({
        "any.required": "Please select Filter Type.",
        "any.empty": "Please select Filter Type.",
      }),
  }).unknown(true); // This allows extra properties to exist in the object without validation.

  return schema.validate(data, {
    abortEarly: false, // This ensures that all validation errors are reported, not just the first one.
  });
};

module.exports = keywordSchema;
